import { Component, NgZone } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Link } from 'src/app/model/result-grid/grid-column-link';
import { Router } from '@angular/router';

@Component({
  selector: 'link-cell-renderer',
  templateUrl: './link-cell-renderer.component.html',
  styleUrls: ['./link-cell-renderer.component.scss']
})
export class LinkCellRenderer implements ICellRendererAngularComp {
  constructor(private router: Router, private zone: NgZone) {

  }
  public generatedUrl!: string;
  public params!: ICellRendererParams & {
    linkData: Link
  };
  agInit(params: ICellRendererParams & {
    linkData: Link
  }): void {
    this.params = params;
    this.setLink();
  }
  refresh(params: ICellRendererParams & {
    linkData: Link
  }): boolean {
    this.params = params;
    this.setLink();
    return true
  }
  private setLink(): void {
    let link = this.params.linkData.urlTemplate;
    this.params.linkData.columnReferences.forEach((columnName, index) => {
      link = link.replace(
        '<colRef_' + index + '>',
        encodeURIComponent(columnName.split('.').reduce((o, i) => o[i], this.params.data))
      );
    })
    this.generatedUrl = this.router.serializeUrl(this.router.createUrlTree([link]));
    if (this.params.context.totalRecords == 1 && this.params.linkData.autoClickIfSingleRecord) {
      this.zone.runOutsideAngular(() => {
        window.open(this.generatedUrl, '_blank')
      });
    }
  }
}
